<template>
  <!--  只允许一个 组件 -->
  <a-layout class="center-container" style="background-color: #fff;">

    <!-- 左侧菜单 '64px' -->
    <a-layout-sider width="200px"
      :style="{ overflow: 'auto', height: '90vh', position: 'fixed', background: '#ffffff', left: 0, top: '65px', bottom: 0 }">
      <a-menu mode="inline" v-model:selectedKeys="currentKeys" v-model:defaultSelectedKeys="currentKeys"
        v-model:openKeys="openKeys" :style="{ height: '100%', borderRight: 0, background: '#ffffff' }"
        @click="handleClick">
        <!-- 欢迎页 -->
        <a-menu-item key="ebooks">
          <!-- <MailOutlined /> -->
          <span>全部</span>
        </a-menu-item>

        <!-- 二级菜单 -->
        <a-sub-menu v-for="item in level1" :key="item.id" :disabled="false">
          <template v-slot:title>
            <span><!--<user-outlined />-->{{ item.name }}</span>
          </template>
          <a-menu-item v-for="child in item.children" :key="child.id">
            <!-- <MailOutlined /> -->
            <span>{{ child.name }}</span>
          </a-menu-item>
        </a-sub-menu>

      </a-menu>
    </a-layout-sider>

    <!--中间布局-->
    <a-layout style="padding-left: 200px;background-color: #fff;">

      <!--中间详细内容 background: '#fff',-->
      <a-layout-content class="center-div"
        :style="{ background: '#fff', padding: '95px 24px 24px 24px', margin: 0, minHeight: '720px' }">
        <!-- 图书列表 -->
        <div class="ebooks" v-show="isShowEbooks">
          <the-ebooks :id="queryCategoryId1" ref="child"></the-ebooks>
        </div>

        <!-- 展示图书列表 -->
        <div v-show="!isShowEbooks">
          <the-ebooks-card :data="ebooks"></the-ebooks-card>
        </div>
      </a-layout-content>

      <!-- 底部 -->
      <TheFooter></TheFooter>

    </a-layout>

    <!-- 返回页面顶部的操作按钮。 -->
    <a-back-top type="default" />

  </a-layout>

</template>

<script lang="ts">
import { defineComponent, onMounted, ref, reactive, toRef } from 'vue';
// 引入axios 库
import axios from "axios";
import { message } from "ant-design-vue";

import { Tool } from "@/util/tool";
import TheEbooks from '@/components/the-ebooks.vue';
import { useRoute } from "vue-router";
import useRouter from '@/router'
import TheEbooksCard from '@/components/the-ebooks-card.vue';
import TheFooter from "@/components/the-footer.vue";

export default defineComponent({
  name: 'HomeView',
  components: {
    TheFooter,
    TheEbooks,
    TheEbooksCard
  },
  setup() {
    console.log('setup ...')

    // 获取url参数 http://localhost:9999/?categoryId=101
    const route = useRoute();
    const categoryId1 = route.query.id1;
    const categoryId2 = route.query.id2;
    const categoryType = route.query.type;
    console.log('categoryId1 => ', categoryId1)
    console.log('categoryId2 => ', categoryId2)
    console.log('categoryType => ', categoryType)

    // 卡页显示
    let currentKeys = ref<string[]>(['ebooks']);

    let ebooks = ref();

    let openKeys = ref();

    let level1 = ref();
    let categorys: any;

    let queryCategoryId1 = ref<number>(-1);

    /**
     * 查询所有分类
     **/
    const handleQueryCategory = () => {

      axios.get("/category/all").then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          categorys = result.data.list;
          console.log("原始数组：", categorys);

          // 加载完分类后，将侧边栏全部展开
          openKeys.value = [];
          for (let i = 0; i < categorys.length; i++) {
            openKeys.value.push(categorys[i].id)
          }

          level1.value = [];
          level1.value = Tool.array2Tree(categorys, 0);
          console.log("树形结构：", level1.value);

        } else {
          message.error(result.message);
        }
      });
    };

    const isShowEbooks = ref(true);
    let currCategoryId = 0;

    /**
     * 查询分类的电子书列表
     */
    const handleQueryEbook = () => {

      axios.post("/ebook/list", {
        page: 1,
        size: 1000,
        categoryId2: currCategoryId,
        status: 1
      }).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          //ref
          ebooks.value = result.data.list
        } else {
          message.error(result.message);
        }
      });
    };

    const handleClick = (value: any) => {
      console.log("menu click", value)
      console.log("currentKeys", currentKeys) // 选中的菜单的 id ==> [401]
      if (value.key === 'ebooks') {
        isShowEbooks.value = true;
        // 请求全部数据
        queryCategoryId1.value = 0
      } else {
        currCategoryId = value.key;
        isShowEbooks.value = false;
        handleQueryEbook();
      }
      // isShowEbooks.value = value.key === 'ebooks';
      // 获取到前面打过标签的元素，将其scrollTop属性设置为0
      document.documentElement.scrollTop = 0
      // 滚动条可能出现在HTML元素上而不是body上，确保兼容性，同时将HTML和body中scrollTop属性设置为0
      document.body.scrollTop = 0
    };


    //处理浏览器URL
    const handleUrl = () => {

      if (categoryId1 != undefined && categoryId2 != undefined && categoryType != undefined) {
        //类型转换一下，否则报错：不能将类型“string | LocationQueryValue[]”分配给类型“string”。
        let currValue2 = (categoryId2 as string) || JSON.stringify(categoryId2);
        console.log('currValue2', currValue2)
        //修改选中项
        currentKeys.value = [currValue2];
        console.log('currentKeys => ', currentKeys)

        //修改浏览器url
        useRouter.push({ path: '/' })
        isShowEbooks.value = false;

        let currType = (categoryType as string) || JSON.stringify(categoryType);
        if (parseInt(currType) == 1) {
          //显示 the-ebooks组件并把categoryId传进组件
          let currValue1 = (categoryId1 as string) || JSON.stringify(categoryId1);
          queryCategoryId1.value = parseInt(currValue1)
          console.log('queryCategoryId1 -------' + queryCategoryId1.value + '----------')
          isShowEbooks.value = true;
          // 触发子组件事件
          //this.$refs.child.handleQueryEbooks(queryCategoryId1);

        } else if (parseInt(currType) == 2) {
          currCategoryId = parseInt(currValue2);
          console.log('currCategoryId', currCategoryId)
          //查询目录所有数据
          handleQueryEbook();
        }

        //handleClick({ key: currValue });

      } else {
        // 请求全部数据
        queryCategoryId1.value = 0
      }
    };


    onMounted(() => {
      console.log('onMounted ...')

      handleQueryCategory();

      // 处理URL
      handleUrl();
    })
    return {
      currentKeys,
      ebooks,

      pagination: {
        onChange: (page: any) => {
          console.log(page);
        },
        pageSize: 3
      },

      actions: [
        { type: 'StarOutlined', text: '' },
        { type: 'LikeOutlined', text: '' },
        { type: 'MessageOutlined', text: '' },
      ],


      handleClick,
      level1,

      isShowEbooks,

      openKeys,

      handleUrl,
      queryCategoryId1,

    }


  }
});
</script>

<style scoped>
/* .site-layout {
  background: #fff;
} */
</style>
